import React from "react";
import { FaStream, FaUserCog, FaCog, FaSignOutAlt, FaRegWindowRestore, FaPaintBrush } from "react-icons/fa";
import { MdMenu, MdFullscreen, MdFullscreenExit, MdCancel } from "react-icons/md";
import { IoMdCloseCircleOutline, IoIosRocket } from "react-icons/io";
import { FcGoogle } from "react-icons/fc";

import { Alert, Button, Popover, PopoverHeader, PopoverBody, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
// import { SketchPicker, SwatchesPicker, BlockPicker } from "react-color";
import SubmitCustom from "../FormComponents/SubmitCustom";

// import {FaSignOut} from "react-icons/fa";
import db from "../../pages";
import { fetchData } from "../common/networkRequests";
import nonvoter from "../../pages/Election/nonvoter";
import ModalArea from "../ModalArea";
import { toDate, handleLogout, RelevantIcon, unsetAllPopovers, checkAccessRights, setCookie, getCookie, toggleSidebar, checkIfFastpathAllowed } from "../oro-module/commonFunctions";
// import ProfilePhoto from "../../images/profile/oro-profile-photo.png";
import BankLogo from "../../images/jsicon-orange.svg";
// import BankLogo from "../../images/login/harco_logo.png";

import JSLogo from "../../images/jsicon-orange.png";
import { handlePageChange } from "../oro-module/ajaxdata";
import { controls } from "../../pages/controls";
import { createComponent } from "../FormArea/FormContent";
import "./navbar.css";
import Select from "react-select";
import ProfilePhoto from "../../images/profile/oro-profile-photo.png";
import ProfilePhoto2 from "../../images/profile/user2.jpeg";
import DefaultPhoto from "../../images/profile/oro-profile-photo-default.png";


let stats = { oro: { photo: DefaultPhoto, awards: [{ id: 1, desc: "Weekly No 1" }, { id: 2, desc: "Monthly No 1" }, { id: 3, desc: "Top Depositor" }, { id: 4, desc: "First to goal" }, { id: 5, desc: "Monthly No 1" }, { id: 6, desc: "Overall Topper" },], progress: 28 }, auditor1: { photo: DefaultPhoto, awards: [{ id: 1, desc: "Weekly No 1" }, { id: 2, desc: "Monthly No 1" }], progress: 18 }, apex: { photo: DefaultPhoto, awards: [{ id: 4, desc: "First to goal" }, { id: 5, desc: "Monthly No 1" }], progress: 18 } }


export const handleAuditBranchChange = (val, current) => {
  let { LocalVars, currentPage } = current.props.parentState;
  let { visiting_branches } = current.props.parentProps.parentState.profile;
  if (!visiting_branches) {
    visiting_branches = [];
  }
  for (var i = 0; i < visiting_branches.length; i++) {
    let vb = visiting_branches[i];
    if (vb['branch_display'] == val.label) {
      val['code'] = vb['branch_code'];
      if (vb['more_1']) {
        val['more_1'] = vb['more_1'];
      }
    }
  }

  LocalVars['selectedTourBranch'] = val;
  current.props.liftGlobalState({ name: 'LocalVars' }, LocalVars);



  // Check if page is visitingBranches, Auto click filter.
  if (!db[currentPage].dashboard) {
    let targetbtn = document.getElementById("action-button-search");
    if (targetbtn) {
      targetbtn.click();
    }
  }

}


const isObjBlank = ({ obj }) => {
  // console.log(obj)
  // loop through VALUES. If ALL are blank THEN ONLY true, else false.
  for (var key in obj) {
    if (obj[key] !== null && obj[key] != "")
      return false;
  }
  return true;
}

/** Show the clicked popover while hiding others */
const handleCustomPopoverClick = (current, popoverID) => {
  let { TopRightMenuStatus } = current.props.parentState;
  let { displayed } = current.state;
  let setted = {};
  unsetAllPopovers();
  current.props.liftGlobalState({ name: "rightSidebarOpen" }, false);

  if (TopRightMenuStatus && TopRightMenuStatus == popoverID) {
    current.props.liftGlobalState({ name: "TopRightMenuStatus" }, false);
    setted[popoverID] = false;
  } else {
    current.props.liftGlobalState({ name: "TopRightMenuStatus" }, popoverID);
    setted[popoverID] = true;
  }
  current.setState({ displayed: setted });
}


const getFastpath = ({ current, searched, LocalVars, currentPage, fastpath }) => {
  current.props.liftGlobalState({ name: 'isPopulating' }, false);
  let currentime = new Date().getTime();
  let { formElements } = current.props.parentState;
  let { dashtime, logintime, loggedintoday } = current.props.parentProps.parentState.profile;
  let blockmsg = "";

  if (dashtime && currentime < (logintime + dashtime) && loggedintoday == 0) {
    blockmsg = `Your admin has made it mandatory that you spend some minimum amount of time at the dashboard area after login. You will be able to change the form after ${parseInt((logintime + dashtime - currentime) / 1000)} seconds.`;
  }
  let { defaultPage } = formElements[currentPage];
  if (blockmsg) {
    alert(blockmsg);
    console.log(109);
  } else {
    LocalVars['searchTime'] = null;
    if (searched != currentPage) {
      current.props.liftGlobalState({ name: 'OriginalData' }, []);
      current.props.liftGlobalState({ name: 'pageData' }, {});
      current.props.liftGlobalState({ name: 'errorMessages' }, {});
      current.props.liftGlobalState({ name: "isSpinnerShow" }, false);

      // if (!defaultPage) {
      //   LocalVars.showFilter = true;
      // } else {
      //   LocalVars.showFilter = false;
      // }

      current.props.liftGlobalState({ name: 'LocalVars' }, LocalVars);
      current.props.liftGlobalState({ name: 'timeTaken' }, false);
    }
    //eslint-disable-next-line
    history.pushState(null, '', '/' + searched);
    current.props.liftGlobalState({ name: "currentPage" }, searched);
    // current.props.liftWrapperState({ name: "currentPage" }, searched);
    current.props.liftGlobalState({ name: 'notifications' }, {});

    LocalVars["sidebarSearch"] = "";
    LocalVars["ShowHistory"] = true;
    current.props.liftGlobalState({ name: 'errorMessages' }, {});
    current.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  }

}


export default class NavbarArea extends React.Component {
  constructor(props) {
    super(props);
    this.setSearchValue = this.setSearchValue.bind(this);
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      isFullScreen: false,
      ttid: "TTID" + String(Math.round(Math.random() * 1000000000)),
      popoverOpen: false,
      tabsPopoverStatus: false, colorPopoverStatus: false,
      colorNameToHex: [],
      modalopen: false,
      popupmessage: "",
      fastpathChange: "",
      displayed: { "profile-menu": false, "help-menu": false, "settings-menu": false }
    };
  }

  generateID() {
    return this.state.ttid;
  }

  handleColorPicker = (color) => {
    // console.log(color)
    this.props.liftGlobalState({ name: "themecolor" }, color);
    this.props.liftWrapperState({ name: "themecolor" }, color);
    setCookie("themecolor", color, 1);
  }



  setSearchValue(e) {
    let { LocalVars } = this.props.parentState;
    LocalVars["globalSearch"] = e.target.value
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  }


  shouldDisplay = () => {
    return true;
  };

  setSidebarSearchValue = e => {
    let { LocalVars } = this.props.parentState;
    LocalVars["sidebarSearch"] = e.target.value.toLowerCase();
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);
  };

  handleFocus = async (e) => {
    // console.log("handle focus")
    let { LocalVars } = this.props.parentState;
    let { sidebarSearch } = this.props.parentState.LocalVars;
    LocalVars["sidebarSearch"] = "";
    this.props.liftGlobalState({ name: "LocalVars" }, LocalVars);

    // 
    let mains = document.getElementsByClassName('fastpath-box-main');
    mains[0].classList.add("selected-box");

  }

  handleBlur = () => {
    let mains = document.getElementsByClassName('fastpath-box-main');
    mains[0].classList.remove("selected-box");
  }

  handleCompressing = (e) => {
    let { remoteip, currentPage, LocalVars } = this.props.parentState
    LocalVars.compressed = e.target.checked;
    this.props.liftState({ name: "LocalVars" }, LocalVars);
  }

  toggleFullScreen = () => {
    let { isFullScreen } = this.state;
    if (document) {
      if (isFullScreen) {
        document.exitFullscreen();
        this.setState({ isFullScreen: false });
      } else {
        document.documentElement.requestFullscreen();
        this.setState({ isFullScreen: true });
      }
    }
  }

  handletoggle = () => {
    let { popoverOpen } = this.state
    this.setState({ popoverOpen: !popoverOpen })
  }

  handleTabsPopoverToggle = () => {
    let { tabsPopoverStatus } = this.state
    this.setState({ tabsPopoverStatus: !tabsPopoverStatus })
  }

  handleColorPopoverToggle = () => {
    let { colorPopoverStatus } = this.state
    let colorhex = [{ label: "gmail", value: "ffffff" }, { label: "violet", value: "4D137F" }, { label: "whatsapp", value: "13735D" }, { label: "pink", value: "F78DA7" }, { label: "black", value: "000000" }, { label: "green", value: "8BC34A" }, { label: "limitless", value: "36424a" }, { label: "apple", value: "1d2b64" }, { label: "react", value: "3494e6" }];

    this.setState({ colorPopoverStatus: !colorPopoverStatus, colorNameToHex: colorhex })
  }


  modalclose = () => {
    let { notifications } = this.props.parentState;
    this.setState({ modalopen: false });
    this.props.liftGlobalState({ name: 'notifications' }, {});
    // this.props.liftState("modalopen", false);
  }

  changeFastpath = () => {
    let { fastpathChange } = this.state
    let { currentPage, LocalVars } = this.props.parentState
    this.setState({ modalopen: false });

    getFastpath({ current: this, searched: fastpathChange, LocalVars, currentPage })
  }

  handleKeyPress = async (e) => {
    if (e.key === "Enter") {
      let searched = e.target.value.toLowerCase();

      // check if fastpath exists in cookie. if exists, then show error and redirect to home. Else proceed.
      let { forms } = this.props.parentProps.parentState.profile;
      let proceed = true //forms[searched];
      let lgs = this.props.liftGlobalState;
      let nots = { value: "Loading...Please wait", alertType: "warning" };

      if (proceed) {
        lgs({ name: 'notifications' }, nots);

        let { token } = this.props.parentProps.parentState;
        let { remoteip, currentPage, LocalVars, notifications, pageData } = this.props.parentState;
        let { showFilter } = LocalVars;

        let response = await checkIfFastpathAllowed({ searched, current: this });

        let { results, exceptions, error, success, proceed, pagename } = response;

        exceptions = []; // Forcefully open pages not in database.

        if (success && proceed) {
          // if (db[pagename]) {
          this.props.liftGlobalState({ name: 'leftSidebar1Selected' }, false);
          // console.log(isObjBlank(pageData))
          if (pageData && isObjBlank({ obj: pageData }) == false && showFilter == false) {
            // this.setState({ popupmessage: "Move away from current page? All the changes will be lost unless saved!", modalopen: true, fastpathChange: searched });
            let moveaway = window.confirm("Do you want to move away from the page? All the unsaved changes will be lost!");
            if (moveaway) {
              getFastpath({ current: this, searched: searched, LocalVars, currentPage, fastpath: searched });
            }
          } else {
            getFastpath({ current: this, searched: searched, LocalVars, currentPage, fastpath: searched });
          }
          // }
          // else { alert("Page doesn't exist"); }
        } else {
          alert("Action is not allowed");
          this.clearNotification();
        }

      } else {
        console.log("ERROR");
        this.props.liftGlobalState({ name: 'notifications' }, { alertType: "error", value: "Not allowed." })
      }
    }
  };

  handleProfileMenu = () => {
    let { showProfile } = this.props.parentState;
    this.props.liftGlobalState({ name: "showProfile" }, !showProfile);
  }

  toggleAdvSearch = (e) => {
    let { advSearch } = this.props.parentState;
    this.props.liftGlobalState({ name: 'advSearch' }, !advSearch ? true : false);
    let t = document.getElementsByClassName('fastpath-box-main')[0];
    let rect = t.getBoundingClientRect();
    this.setState({ morex: rect.x + 15, morewidth: rect.width });
  }

  // componentDidMount() {
  //   let { notifications } = this.props;
  //   console.log(notifications)
  // } 

  clearNotification = () => {
    this.props.liftGlobalState({ name: 'notifications' }, {});
  }

  customFilter = (option, searchText) => {
    if (
      option.data.label.toLowerCase().includes(searchText.toLowerCase())
    ) {
      return true;
    } else {
      return false;
    }
  }

  render() {
    const tooltipID = this.generateID();
    let { isFullScreen, displayed, morex, morewidth } = this.state;
    let {
      notifications, ShowSidebar, LocalVars, themecolor, advSearch, currentPage
    } = this.props.parentState;
    let { session_date, user_code, user_description, assigned_roles, profile } = this.props.parentProps.parentState;
    let { sidebarSearch, compressed, selectedTourBranch } = LocalVars;

    if (notifications.value && notifications.value != "" && notifications.alertType == 'error') {
      let x = notifications.value;
      alert(x);
      this.props.liftGlobalState({ name: 'notifications' }, {});
      console.log({ LN: 360, notifications });
    }

    let x;
    !themecolor ? themecolor = "default" : x = 0;
    const current = this;

    let allc = [
      ...controls.displayText({ label: "Branch", width: "col-sm-4" }),
      ...controls.branch({ defaultValue: "assigned_branch", width: "col-sm-4", isReadOnly: true, isRequired: true, star: true }),
      ...controls.showData({ data: "branch_display", name: "branch_display", width: "col-sm-4" }),

      ...controls.magicDateLabel({ tab: "filter", star: true, label: "As on Date", width: "col-sm-4", target: "as_on_date" }),
      ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-4", dateType: "ontype", isRequired: true, default: "sessiondate" }),
      ...controls.displayText({ tab: "filter", width: "col-sm-4" })
    ]

    let { username, visiting_branches, client_name, roles, logo_url, icon_url } = profile;
    let branch_filter_options = {};
    if (!visiting_branches) { visiting_branches = []; }
    visiting_branches.map(({ branch_display, branch_uid }) => branch_filter_options[branch_display] = branch_uid)
    let branch_options = Object.keys(branch_filter_options).map(bf => { return { label: bf, value: branch_filter_options[bf] } })
    let vbranches = db[currentPage].visitingBranches;

    if (currentPage == 'dashboard1') {
      let x;
      roles.map(role => role.role == 'Tehsildar' ? vbranches = false : x = 1)
    }

    let iconstyle = { height: 50 };
    if (icon_url && icon_url.indexOf('harco') != -1) {
      iconstyle = { width: 50 };
    }
    return (
      <div
        className={`col-sm-12  ${themecolor}-navbar-theme noprint sticky-top`}
      >
        <div className="row">
          {this.state.modalopen && (
            <Modal isOpen={this.state.modalopen} toggle={this.modalclose} >
              <ModalHeader toggle={this.modalclose}></ModalHeader>
              <ModalBody>
                {this.state.popupmessage}
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={this.changeFastpath}>Yes</Button>
                <Button color="secondary" onClick={this.modalclose}>Cancel</Button>
              </ModalFooter>
            </Modal>
          )
          }

          <div style={{ paddingLeft: 0, width: "7%", float: "left" }}>
            <div
              style={{
                marginLeft: 10,
                paddingTop: 4,
                float: "left"
              }}
            >
              <button
                id="logout-button-hidden"
                className="border-light list-group-item-action list-group-item"
                style={{ display: "none" }}
                onClick={() => handleLogout(this)}
              />

              {/* <IoIosRocket
                style={{
                  fontSize: "25px",
                  color: "gray"
                }}
                onClick={this.toggleSidebar}
                className={`hand btnSecondary ${themecolor}-hamburger-icon
                ${this.props.parentState.LocalVars.sidebarOpenButtonClass}
                  `}
              /> */}

              {/* <img src={JSLogo} className="applogo hand" onClick={this.toggleSidebar} /> */}
              <img src={icon_url} style={iconstyle} className="applogo hand"
                onClick={() => handlePageChange({ current, item: { fastpath: "dashboard1", label: "Dashboard" } })}
              // onClick={this.toggleSidebar} 
              />

              &nbsp;
            </div>
            <div style={{ height: 40, float: "left" }} onClick={() => handlePageChange({ current, item: { fastpath: "dashboard1", label: "Dashboard" } })}>
              <div
                className={`hand ${themecolor}-logo-text`}
                style={{ fontSize: "21px", fontStyle: "italic" }}
              >
              </div>
            </div>
          </div>


          <div className="" style={{ float: "left", width: "93%" }}>
            <div className="row" style={{ marginRight: 0, paddingLeft: 16 }}>

              {/* <div className="col-2 fastpath-box-main" style={{ paddingLeft: 10 }}>
                <div style={{ float: "left", paddingTop: 12, width: "10%" }}>
                  <RelevantIcon style={{ fontSize: 22, color: "gray" }} icon="search" />
                </div>
                <div style={{ float: 'left', paddingTop: 10, width: "90%" }} className="searchinput-container">
                  <input
                    autoComplete="off"
                    type="text"
                    id="fastpath-textbox"
                    className={` ${themecolor}-fastpath`}
                    name="search"
                    placeholder="Fast Path . . ."
                    value={sidebarSearch}
                    onChange={this.setSidebarSearchValue}
                    onKeyPress={this.handleKeyPress}
                    onFocus={this.handleFocus}
                    onBlur={this.handleBlur}
                  />
                </div>
              </div> */}


              {notifications && notifications.value && (notifications.alertType == 'message' || notifications.alertType == 'warning' || notifications.alertType == 'success') &&

                <div className="col-12" style={{ overflow: "none" }}>

                  <div style={{ textAlign: "center", paddingTop: 10 }}>
                    <span className={`${notifications.alertType} ${themecolor}-notifications`} > {String(notifications.value)}</span> &nbsp;

                    {notifications.alertType != 'warning' &&
                      <RelevantIcon icon="tick" className={` hand`} color="green" onClick={this.clearNotification} />
                    }

                    {notifications.alertType == 'warning' &&
                      <RelevantIcon icon="cross" className={` hand`} color="red" onClick={this.clearNotification} />
                    }
                  </div>
                </div>
              }


              {!notifications || !notifications.value &&

                <div className="col-5" style={{ overflow: "none" }}>
                  {visiting_branches.length > 0 && vbranches && vbranches != "readonly" && (!notifications || !notifications.value) &&
                    <div className="col-sm-12 row" style={{ textAlign: "center", paddingTop: 3 }}>
                      {/* <div className="col-sm-4 d-none d-lg-block" style={{ marginTop: 6 }}>
                      Select Branch
                    </div> */}

                      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <Select
                          closeOnSelect={true}
                          onChange={(e) => handleAuditBranchChange(e, current)}
                          filterOption={this.customFilter}
                          placeholder="Select Branch"
                          options={branch_options}
                          // removeSelected={true}
                          rtl={false}
                          value={!selectedTourBranch ? branch_options[0] : selectedTourBranch}
                        />
                      </div>
                    </div>
                  }

                  {visiting_branches.length > 0 && vbranches && vbranches == "readonly" && (!notifications || !notifications.value) &&
                    <div className="col-sm-12 row" style={{ textAlign: "center", paddingTop: 3 }}>
                      <span className="selected-branch-readonly">{selectedTourBranch.label}</span>
                    </div>
                  }
                  {/* <div className={`${themecolor}-notifications`} style={{}} id="notifications-area"></div> */}
                </div>
              }
              {!notifications || !notifications.value &&
                <div className="col-7 text-right bellArea" id="notifications-area">
                  <div id={tooltipID} style={{ float: "right" }}>
                    <div className="d-none d-lg-block" style={{ float: "left" }}>
                      {client_name == 'Apex Bank' && username != 'oro' &&
                        <div className="bankname-internal">

                          <div style={{ marginTop: 11 }}>
                            Decision Machines Pvt Ltd
                          </div>
                        </div>
                      }
                      {username == 'oro' &&
                        <div className="bankname-internal">
                          <div style={{ marginBottom: -5 }}>
                            The ORO
                          </div>
                          <div >
                            Administrator
                          </div>
                        </div>
                      }

                      {client_name &&
                        <div className="bankname-internal">
                          <div style={{ marginTop: 11 }}>
                            {client_name}
                          </div>
                        </div>
                      }
                    </div>

                    {/* <div className={`clickable-icon-container ${displayed["help-menu"] ? "hovered" : ""}`} onClick={() => handleCustomPopoverClick(this, "help-menu")} style={{ float: "left" }}>
     <RelevantIcon icon="question-circle" className={`${themecolor}-icon`} style={{ fontSize: 25, verticalAlign: "middle", color: "#5F6368" }} />
   </div>

   <div className={`clickable-icon-container ${displayed["language-menu"] ? "hovered" : ""}`} onClick={() => handleCustomPopoverClick(this, "language-menu")} style={{ float: "left" }}>
     <RelevantIcon icon="language" className={`${themecolor}-icon`} style={{ fontSize: 25, verticalAlign: "middle", color: "#5F6368" }} />
   </div>

   <div className={`clickable-icon-container ${displayed["settings-menu"] ? "hovered" : ""}`} onClick={() => handleCustomPopoverClick(this, "settings-menu")} style={{ float: "left" }}>
     <RelevantIcon icon="settings" className={`${themecolor}-icon`} style={{ fontSize: 25, verticalAlign: "middle", color: "#5F6368" }} />
   </div> */}


                    <div id="profile-clicker" onClick={this.handleProfileMenu} className={`profile-clicker ${displayed["profile-menu"] ? "hovered" : ""} ${themecolor}-profile-clicker`} style={{ float: "left" }}>
                      <div >
                        <img className={`${themecolor}-profile-photo profile-photo`} src={(stats[user_code] && stats[user_code]['photo']) ? stats[user_code]['photo'] : DefaultPhoto} />
                      </div>
                    </div>

                  </div>
                </div>



              }

            </div>
          </div>
        </div>
      </div >
    );
  }
}
